/*
 * virtualpaging
 *
 * - settings
 * - helpers
 * - disableVirtualpaging
 * - sendPageview
 * - listenForSubmit
 * - listenForTogglePages
 * - checkForErrors
 * - listenForHashChanges
 * - showFirstPage
 *
 * Dependencies
 * - jQuery Validate https://jqueryvalidation.org/
 */

export default function virtualpaging() {
  /*
   * settings
   */
  const settings = {
    headingSelector: undefined,
    scrollToTopSpeed: 100,
    scrollToHeadingSpeed: 0,
    scrollToFirstErrorSpeed: 0,
    inputErrorClass: "input-validation-error",
    fieldErrorClass: "field-validation-error",
    validClass: "valid",
    defaultErrorKey: "additional",
    canPaginateBack: true,
  };

  if (
    settings.headingSelector !== undefined &&
    $(settings.headingSelector).length === 0
  ) {
    window.log(
      "Settings.headingSelector is invalid in virtualpaging.js, element can not be found."
    );
  }
  if (settings.defaultErrorKey === undefined) {
    window.log(
      "Settings.defaultErrorKey is undefined in virtualpaging.js. Please define so that backend errors can be displayed."
    );
  }
  if (
    settings.defaultErrorKey !== undefined &&
    $(`[data-valmsg-for="${settings.defaultErrorKey}"]`).length === 0
  ) {
    window.log(
      "(ignore if not on dotnet) Settings.defaultErrorKey is defined in virtualpaging.js but a corresponding element does not exist."
    );
  }

  /*
   * helpers
   * - scrollToTop
   * - scrollToHeading
   * - scrollToFirstError
   * - scrollAfterVirtualpageChange
   * - inputsToValidate
   * - inputsToCheck
   * - pageHasErrors
   * - getHash
   * - setHash
   * - hidePreviousMaterials
   * - showNextMaterials
   */

  function scrollToTop() {
    $("html,body").animate({ scrollTop: 0 }, settings.scrollToTopSpeed);
  }

  function scrollToHeading() {
    if (settings.headingSelector !== undefined) {
      const scrollTo = $(`${settings.headingSelector}:visible`)[0];
      scrollTo.scrollIntoView();
    } else {
      $(".body-wrapper")[0].scrollIntoView();
    }
  }

  function scrollToFirstError() {
    const firstInput = $(`.${settings.inputErrorClass}:visible`)[0];
    const firstField = $(`.${settings.fieldErrorClass}:visible`)[0];
    const documentScrollTop = Math.abs(
      document.querySelector(".body-wrapper").getBoundingClientRect().top
    );
    const scrollToInput =
      firstInput === undefined
        ? 0
        : window.findPos(firstInput)[0] + documentScrollTop;
    const scrollToField =
      firstField === undefined
        ? 0
        : window.findPos(firstField)[0] + documentScrollTop;
    const scrollTo = Math.round(
      scrollToInput < scrollToField ? scrollToInput : scrollToField
    ); // animate scrollTop on iOS won't work if not rounded
    $("html, body").animate(
      { scrollTop: scrollTo },
      settings.scrollToFirstErrorSpeed
    );
  }
  window.scrollToFirstError = scrollToFirstError;

  function scrollAfterVirtualpageChange() {
    if (window.isDesktop()) {
      scrollToTop();
    } else if (window.isMobile()) {
      scrollToHeading();
    }
  }

  function inputsToValidate() {
    if ($("[name=postal-code]").is(":visible")) {
      /* Do not revalidate address inputs since they have special validation */
      /* HOWEVER if postal-code and house-number don't have any validation classes, then trigger validation */
      if (
        (!$("[name=postal-code]").hasClass(settings.validClass) &&
          !$("[name=postal-code]").hasClass(settings.inputErrorClass)) ||
        (!$("[name=house-number]").hasClass(settings.validClass) &&
          !$("[name=house-number]").hasClass(settings.inputErrorClass))
      ) {
        $(
          "[name=postal-code],[name=house-number],[name=city],[name=street-name]"
        ).trigger("blur");
      }
      return $(
        "input:visible:not([name=postal-code]):not([name=house-number]):not([name=house-number-extension]), .js-address-lookup input"
      );
    }
    return $("input:visible");
  }

  function inputsToCheck() {
    /* If address is visible, add the hidden address inputs */
    if ($("[name=postal-code]").is(":visible")) {
      return $("input:visible, .js-address-lookup input");
    }
    return $("input:visible");
  }
  window.inputsToCheck = inputsToCheck;

  function pageHasErrors() {
    if (inputsToValidate().length !== 0) {
      inputsToValidate().valid();
      if (inputsToCheck().hasClass(settings.inputErrorClass)) {
        return true;
      }
    }
    return false;
  }

  function getHash(hash) {
    const currentHash = hash !== undefined ? hash : window.location.hash;
    let retval = 1;

    if (currentHash !== "" && currentHash.length > 1) {
      const x = currentHash.indexOf("#") + 1;
      const y = currentHash.indexOf("?");
      if (y === -1) {
        retval = currentHash.substring(x);
      } else if (y < x) {
        retval = currentHash.substring(x);
      } else {
        retval = currentHash.substring(x, y);
      }
    }
    if (retval === "" || retval == null) {
      retval = 1;
    }
    if (Number.isNaN(Number(retval))) {
      window.log(
        `Hash is not a number in function getHash in virtualpaging.js:${retval}`
      );
    }
    return retval;
  }

  function setHash(no) {
    window.location.hash = `#${no}`;
  }

  function hidePreviousMaterials() {
    $('[id^="material-"]').attr("style", null);
  }
  window.hidePreviousMaterials = hidePreviousMaterials;

  function showNextMaterials(no) {
    const currentNo = no || window.currentpageno;
    const $materials = window.getMaterialsForPage(currentNo);
    if ($materials === undefined) {
      return;
    }
    $materials.show();
    const length = window.getPageCountForFlow();
    for (let i = 0; i < length; i += 1) {
      const pageno = i + 1;
      $("body").removeClass(`page-${pageno}`);
    }
    $("body").addClass(`page-${currentNo}`);
  }
  window.showNextMaterials = showNextMaterials;

  /*
   * disableVirtualpaging
   *
   * adds the virtualpaging-is-disabled class to the body
   * the css will then take care of showing the entire form on a single page
   * and hiding any page-specific content (virtualpaging-tools)
   */

  function disableVirtualpaging() {
    $("body").addClass("virtualpaging-is-disabled");
  }
  window.disableVirtualpaging = disableVirtualpaging;

  /**
   * sendPageview
   *
   * function used to sent the 'page' event and 'navigation' event
   * all events can be inspected by executing gdl('debug') in the browser's console
   *
   * Pageview: The custom URL to sent to GA. Should start with '/'
   */
  function sendPageview(stepName, stepNumber) {
    // Retrieve the current page details
    var pageDetails = window.currentPageDetails;

    if (window.new_gdl && pageDetails) {
      // Update the page details with the new page data
      pageDetails.page_funnel_step_name = stepName.replace("/", "");
      pageDetails.page_funnel_step_number = stepNumber;
      pageDetails.page_path = stepName;
      pageDetails.page_url = window.location.href;

      // Submit the details
      window.new_gdl.setPageDetails(pageDetails);
    } else {
      window.log(
        `(no window.new_gdl) would send page details: ${stepName} (no. ${stepNumber})`
      );
    }
  }

  /**
   * changePage
   * Executes all the steps neccesary to change to a new page
   */
  function changePage(dontChangeHash) {
    /* Values: Update spans with input values */
    window.updateStringValues();

    /* Pageview: Send pageview */
    var pageNumber = window.currentpageno;
    var pageName = window.getPageviewForPage(pageNumber);
    sendPageview(pageName, pageNumber);

    /* Hash: Change hash */
    if (!dontChangeHash) {
      setHash(pageNumber);
    }

    /* Materials: Hide current page materials */
    hidePreviousMaterials();

    /* Materials: Show new page materials */
    showNextMaterials(pageNumber);

    /* Carousels: Resize any visible carousels */
    window.resizeVisibleCarousels();

    /* Scroll: According to settings, scroll to top or heading or none */
    scrollAfterVirtualpageChange();
  }
  window.changePage = changePage;

  /**
   * listenForSubmit
   *
   * form on submit listener
   * listens to the button.submit material
   * - prevents default and only triggers submit if there are no errors on the page
   */
  let doublepostboolean = false;
  function listenForSubmit() {
    $("form").on("submit", function handleSubmit(e) {
      e.preventDefault();

      /* Errors: Page has errors */
      if (pageHasErrors()) {
        scrollToFirstError();
        return;
      }
      /* Errors: Page has no errors */

      if (window.submitButtonIsDisabled()) {
        return;
      }

      /* Submit button: Disable and show a submitting animation, to avoid multiple submits */
      window.disableSubmitButton();
      if (doublepostboolean) {
        return;
      }
      doublepostboolean = true;

      /* Submit form */
      this.submit();
    });
  }
  listenForSubmit();

  function requiredItemsAreNotFilled() {
    const $els = $(
      "input[data-val-required]:visible, textarea[data-val-required]:visible, select[data-val-required]:visible"
    );
    let emptyExists = false;
    $els.each((index, $el) => {
      const type = $el.getAttribute("type");
      const name = $el.getAttribute("name");
      const val = $($el).val();
      if (type === "radio" || type === "checkbox") {
        emptyExists = $(`input[name=${name}]:checked`).length === 0;
      } else if (!val || val.length === 0) {
        emptyExists = true;
      }
    });
    return emptyExists;
  }

  function listenForChange() {
    $("form").on("change", (e) => {
      if ($(".js-button-on-valid.is-hidden:visible").length === 0) {
        return;
      }

      if ($(".js-address:visible").length === 1) {
        $(".js-button-on-valid:visible").removeClass("is-hidden");
        return;
      }

      $(e.target).valid();

      if ($(".input-validation-error").length > 0) {
        return;
      }

      if (requiredItemsAreNotFilled()) {
        return;
      }

      if (pageHasErrors()) {
        return;
      }

      // Show button
      $(".js-button-on-valid:visible").removeClass("is-hidden");
    });
  }
  listenForChange();

  /*
   * listenForValidatePages
   *
   * js-validate-page on click listener
   * Used for validating a page despite virtualpaging
   */
  function listenForValidatePages() {
    $(".js-validate-page").on("click", (e) => {
      e.preventDefault();

      /* Errors: Page has errors */
      if (pageHasErrors()) {
        scrollToFirstError();
        return; // eslint-disable-line no-useless-return
      }
    });
  }
  listenForValidatePages();

  if (!$("body").hasClass("js-virtualpaging")) {
    return;
  }

  /*
   * listenForTogglePages
   *
   * js-toggle-page on click listener
   * listens to the button.virtual material
   */
  function togglePage() {
    /* Errors: Page has errors */
    if (pageHasErrors()) {
      scrollToFirstError();
      return;
    }
    /* Errors: Page has no errors */

    /* Pagenumber: Set new */
    window.currentpageno++;

    /* Execute all functions needed when changing a page */
    window.changePage();
  }
  function listenForTogglePages() {
    $(".js-toggle-page").on("click", (e) => {
      e.preventDefault();

      togglePage();
    });
  }
  listenForTogglePages();

  /*
   * listenForEnter
   *
   * js-toggle-page on click listener
   * listens to the button.virtual material
   */

  function listenForEnter() {
    const $els = $("input, textarea");
    $els.on("keyup", (e) => {
      if (e.keyCode === 13) {
        $(e.target).blur();
        togglePage();
      }
    });
  }
  listenForEnter();

  /*
   * checkForErrors
   *
   * finally, on page load, check for the existence of an error (generally passed by backend, like a VAC)
   * if there is an error, display the page with the error
   *
   * function can be used by passing a specific key e.g. instant-win-code
   * if no key is passed, we check for the default error key
   * this is the "ErrorShowKey" in campaign pages
   * the default error key's validation span is generally placed above the submit button of the page
   */
  let wentToSomeError = false;
  function checkForErrors() {
    const $validationSpan = $("[data-valmsg-for].field-validation-error");

    if ($validationSpan.children().length !== 0) {
      const id = $validationSpan
        .children()
        .first()
        .closest('[id^="material"]')
        .attr("id");
      const key = id.substring(id.indexOf("material-") + "material-".length);
      /* Pagenumber: Set new */
      window.currentpageno = window.getPageForMaterial(key);

      /* Set the correct pageview */
      window.custompageview = window.getPageviewForPage(window.currentpageno);
      if (window.currentGdlEvnt) {
        if (window.custompageview !== undefined) {
          window.currentGdlEvnt.navigation.url_path = window.custompageview;
        }
      }

      /* Materials: Show new page materials */
      showNextMaterials(window.currentpageno);

      /* Carousels: Resize any visible carousels */
      window.resizeVisibleCarousels();

      /* Add virtualpaging loaded class to the body */
      $("body").addClass("is-loaded");

      if (key !== settings.defaultErrorKey) {
        window.log(
          `An error besides the settings.defaultErrorKey is returned from the backend. Please check your campaign-pages if the given field is properly setup (ie should it be required or not). Key: ${key}`
        );
      }
      wentToSomeError = true;
    }
  }
  window.checkForErrors = checkForErrors();
  checkForErrors();

  function showFirstPage() {
    /* Materials: Show new page materials */
    showNextMaterials(1);

    /* Carousels: Resize any visible carousels */
    window.resizeVisibleCarousels();

    /* Add virtualpaging loaded class to the body */
    $("body").addClass("is-loaded");
  }
  if (!wentToSomeError) {
    showFirstPage();
  }

  /*
   * listenForHashChanges
   *
   * we are using hashes so that the user can go back (not forth) through the virtual pages
   * that's why we change the hash if the user goes to the next page, and why we have a hashchange listener
   * listen for hashchanges so that the correct virtual page is shown if the user goes back
   *
   */

  function listenForHashChanges() {
    function didGoBack(newURL, oldURL) {
      const newPageNo = getHash(newURL);
      const oldPageNo = getHash(oldURL);
      return oldPageNo > newPageNo;
    }

    function locationHashChangedBack(e) {
      if (didGoBack(e.newURL, e.oldURL)) {
        /* Pagenumber: Set new */
        window.currentpageno = getHash(e.newURL);

        /* Execute all functions needed when changing a page, pass 'true' so hash doesn't change (hahs would trigger hashchange event) */
        window.changePage(true);
      }
    }
    window.addEventListener("hashchange", locationHashChangedBack);
  }
  if (settings.canPaginateBack) {
    listenForHashChanges();
  }
}
